import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-no-permission',
  imports: [TranslateModule],
  templateUrl: './no-permission.component.html',
  styleUrl: './no-permission.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoPermissionComponent {}
